import getConfig from '~/config';
import { getAxiosClient } from './common';

const config = getConfig();
const axios = getAxiosClient();

export async function query(layerId: string, bounds: [number, number, number, number], z: number) {
  const { data } = await axios({
    method: 'POST',
    url: `${config.tileServerBase}/v1/tiles/${layerId}/query`,
    data: {
      bounds,
      z,
    },
  });
  return data;
}
